module.exports = __webpack_public_path__ + "static/media/barra-de-sao-miguel-al.c08abb70.jpg";